import ChevronRight from "/public/images/icons/chevronRight.svg?react";
import { useThemeContext } from "../../context/themeContext";
import { useState } from "react";
import { motion } from "framer-motion";
import PropTypes from "prop-types";
import MedicalIcon from "/public/images/icons/medicalIcon.svg?react";
import AllergyIcon from "/public/images/icons/allergiesIcon.svg?react";
import MedicationIcon from "/public/images/icons/medicationsIcon.svg?react"
import ContactIcon from "/public/images/icons/phone.svg?react"

export default function Dropdown({ icon, title, children, isActive, locked }) {
  const [active, setActive] = useState(isActive || false);
  const { theme } = useThemeContext();

  return (
    <div
      className={`flex flex-col justify-between ${
        active
          ? theme === "staff"
            ? "border-[#1877D3]"
            : "border-[#EAAA00]"
          : "border-[#E3E3E3]"
      } bg-white border rounded-[8px] p-6`}
      data-testid="dropdown-container"
    >
      <div className={`flex justify-between min-w-full`} onClick={() => !locked && setActive(!active)}>
        <div className="flex flex-row items-center gap-x-[20px]">
          {icon && (
              icon === "medical" ? <MedicalIcon className="w-[24px] h-[24px]" />
              : icon === "allergy" ? <AllergyIcon className="w-[24px] h-[24px]" />
              : icon === "medication" ? <MedicationIcon className="w-[24px] h-[24px]" />
              : icon === "contact" ? <ContactIcon className="w-[24px] h-[24px]" />
              : null
          )}

          <div className="flex flex-row items-center w-full font-semibold antialiased gap-x-2">
            {title}
          </div>
        </div>
        {!locked && (
          <div className="">
            <ChevronRight
              data-testid="dropdown-icon"
              className={` ${
                active
                  ? theme === "staff"
                    ? "fill-[#1877D3] -rotate-90"
                    : "fill-[#EAAA00] -rotate-90"
                  : "fill-black rotate-90"
              } transition-all cursor-pointer`}
            />
          </div>
        )}
      </div>
      <motion.div
        initial={false}
        animate={{
          height: active ? "auto" : 0,
          marginTop: active ? "24px" : 0,
        }}
        transition={{ duration: 0.5 }}
        className={`overflow-hidden px-2 border-dashed border-t border-transparent ${
          active && "!border-[#E3E3E3]"
        }`}
        data-testid="dropdown-content"
      >
        <div className="flex flex-col gap-0 pt-[24px]">{children}</div>
      </motion.div>
    </div>
  );
}

Dropdown.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  icon: PropTypes.node,
  children: PropTypes.node.isRequired,
  locked: PropTypes.bool,
};
